module.exports = __webpack_public_path__ + "img/P30.465f5b8b.png";